import React from 'react';
import moment from 'moment';
import { formatThaiDateUi } from '../../../../utils/DateUtils';
const ServiceRecordsTable = ({ records, errors, onEdit, onDelete, onAdd }) => {
  const TABLE_FIELDS = [
    {
      key: "itemNo",
      label: "ครั้งที่",
      w: "5%",
      alignHeader: "center",
      align: "center",
    },
    {
      key: "serviceDate",
      label: "วันที่เข้าบริการ",
      w: "7%",
      alignHeader: "center",
      align: "center",
      format: value => value ? formatThaiDateUi(value) : "ไม่มีวันที่เข้าบริการ"
    },
    {
      key: "nextAppointment",
      label: "วันนัดหมาย",
      w: "7%",
      alignHeader: "center",
      align: "center",
      format: value => value ? formatThaiDateUi(value) : "ไม่มีวันนัดหมาย"
    },
    {
      key: "serviceType",
      label: "ประเภทบริการ",
      w: "10%",
      alignHeader: "center",
      align: "center",
      fallback: "ไม่มีประเภทบริการ",
      format: item => item?.label || "ไม่มีประเภทบริการ"
    },
    {
      key: "desc",
      label: "รายละเอียด",
      w: "15%",
      alignHeader: "center",
      align: "start",
      fallback: "ไม่มีรายละเอียด"
    },
    {
      key: "detail",
      label: "รายละเอียดการปฎิบัติงาน",
      w: "15%",
      alignHeader: "center",
      align: "start",
      fallback: "ไม่มีรายละเอียด"
    },
    {
      key: "status",
      label: "สถานะ",
      w: "10%",
      alignHeader: "center",
      align: "center",
      fallback: "รอเข้าพบ",
      format: status => status?.label || "รอเข้าพบ"
    },
    {
      key: "employee",
      label: "พนักงาน",
      w: "10%",
      alignHeader: "center",
      align: "center",
      fallback: "ไม่มีพนักงาน",
      format: emp => emp?.value?.name || emp?.name || "ไม่มีพนักงาน"
    }

  ];
  return (
    <div className="card mb-4">
      <div className="card-header d-flex justify-content-between align-items-center">
        <div>
          <h5 className="mb-0">รายละเอียดงาน</h5>
          {errors.serviceRecords && (
            <small className="text-danger">{errors.serviceRecords}</small>
          )}
        </div>
        <button
          type="button"
          className="btn btn-sm btn-outline-orange"
          onClick={onAdd}
        >
          <i className="fas fa-plus me-1"></i> เพิ่มรายการ
        </button>
      </div>

      <div className="card-body p-0">
        <div className="table-responsive">
          <table className="table table-striped table-hover mb-0">
            <thead className="thead-dark">
              <tr>
                {TABLE_FIELDS.map(field => (
                  <th
                    key={field.key}
                    style={{ width: field.w }}
                    className={`text-${field.alignHeader || 'start'}`}
                  >
                    {field.label}
                  </th>
                ))}
                <th className="text-center" style={{ width: '5%' }}>การจัดการ</th>
              </tr>
            </thead>
            <tbody>
              {records.length > 0 ? (
                [...records]
                  .sort((a, b) => a.itemNo - b.itemNo)
                  .map((record, index) => (
                    <tr key={record.id}>
                      {TABLE_FIELDS.map(field => {
                        const raw = record[field.key];
                        const value = field.format
                          ? field.format(raw)
                          : (raw || field.fallback || '');

                        return (
                          <td
                            key={field.key}
                            className={`text-${field.align || 'start'}`}
                          >
                            {value}
                          </td>
                        );
                      })}
                      <td className="text-center">
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() => onEdit(record)}
                          title="แก้ไข"
                        >
                          <i className="fa fa-edit text-warning"></i>
                        </button>
                        <button
                          type="button"
                          className="btn btn-link text-danger p-0 ms-2"
                          onClick={() => onDelete(record.id)}
                          title="ลบ"
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan={TABLE_FIELDS.length + 1} className="text-center text-muted py-4">
                    <i className="fas fa-inbox fa-2x mb-2"></i><br />
                    ไม่มีรายการบริการ
                  </td>
                </tr>
              )}
            </tbody>


          </table>
        </div>
      </div>
    </div>
  );
};



export default ServiceRecordsTable;
